<template>
    <div id="forgot">
        <b-container fluid
            id="container">
            <b-row no-gutters>
                <b-col cols="6"
                    id="left"></b-col>
                <b-col cols="6"
                    id="right">
                    <b-row no-gutters>
                        <b-col cols="3"></b-col>
                        <b-col cols="6">
                            <logo-vertical></logo-vertical>
                            <forgot-form></forgot-form>
                        </b-col>
                        <b-col cols="3"></b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import ForgotForm from '@/components/forgot/ForgotForm.vue'
import LogoVertical from '@/components/ui/LogoVertical.vue'

export default {
    name: 'Forgot',
    components: {
        ForgotForm,
        LogoVertical
    }
}
</script>
